import React from 'react';
import Helmet from "react-helmet/es/Helmet";
import {getStore} from "trim-redux";
import { buildHelmetTitle } from "../../../config/normalizeHelmetTitle";

export default function HeaderTags(props) {
    const app_name = getStore('app_name');
    const titleText = buildHelmetTitle(app_name, props.title, { loader: props.loader });

    return (
        <Helmet>
            <title>{titleText}</title>
            <link rel="canonical" href={window.location.href} />
        </Helmet>
    );
}
